import React, { Component } from "react";
import _ from "lodash";
import moment from "moment";

class STableBody extends Component {
  renderCell = (item, column, index, currentPage, limit) => {
    if (column.content) return column.content(item, index, currentPage, limit);
    if (column.path.indexOf("date") >= 0)
      return _.get(item, column.path)
        ? moment(_.get(item, column.path)).format("DD-MM-YYYY")
        : "-";

    return _.get(item, column.path);
  };

  createKey = (item, column) => {
    return item._id + (column.path || column.key);
  };

  render() {
    const { data, columns, keyId, currentPage, limit } = this.props;

    return (
      <tbody>
        {data && data.length > 0 ? (
          data.map((item, index) => (
            <tr key={item._id || index + item[keyId]}>
              {columns.map(column => (
                <td
                  key={this.createKey(item, column)}
                  style={{
                    textAlign: column.textAlign ? column.textAlign : "left"
                  }}
                >
                  {this.renderCell(item, column, index, currentPage, limit)}
                </td>
              ))}
            </tr>
          ))
        ) : (
          <tr>
            <th colSpan="99" style={{ textAlign: "center" }}>
              No Data
            </th>
          </tr>
        )}
      </tbody>
    );
  }
}

export default STableBody;



// WEBPACK FOOTER //
// ./src/components/Common/STableBody.jsx